module.exports = __webpack_public_path__ + "img/mm-profile-dummy-male@3x.f9e62eba.png";